import React from "react";
import { useTranslation } from "react-i18next";

function InputEmail(props) {
	const { t } = useTranslation();
	const { register, errors, defaultValue, disabled } = props;

	return (
		<div className="formField">
			<label htmlFor="email">{t("pageProfile.form.label.email")}</label>
			<input
				type="email"
				defaultValue={defaultValue}
				disabled={disabled}
				className={errors.email ? "error" : ""}
				{...register("email", { required: !disabled, maxLength: 50, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i })}
			/>
			<ul className="errors">
				{errors?.email?.types?.required && <li className="error">{t("pageProfile.form.error.email.required")}</li>}
				{errors?.email?.types?.maxLength && <li className="error">{t("pageProfile.form.error.email.length")}</li>}
				{errors?.email?.types?.pattern && <li className="error">{t("pageProfile.form.error.email.pattern")}</li>}
			</ul>
		</div>
	);
}

export default InputEmail;
